(function () {
  var CFG = window.MQ_WELCOME_OFFER || {};
  var STORAGE_SUB = 'mq_welcome_subscribed';
  var STORAGE_DISMISS = 'mq_welcome_dismissed';
  var STORAGE_DISCOUNT_ACTIVE = 'mq_discount_active';
  var DISMISS_DAYS = 14;

  var root = document.getElementById('mqWelcomePopup');
  if (!root || !CFG.klaviyoCompanyId || !CFG.klaviyoListId) return;

  var steps = root.querySelectorAll('.mq-welcome-popup__step');
  var form = root.querySelector('.mq-welcome-popup__form');
  var emailInput = root.querySelector('.mq-welcome-popup__input');
  var errorEl = root.querySelector('.mq-welcome-popup__error');
  var tryBtn = document.getElementById('mqWelcomeTry');
  var copyBtn = document.getElementById('mqWelcomeCopy');
  var activateBtn = document.getElementById('mqWelcomeActivate');
  var codeEl = document.getElementById('mqWelcomeCode');
  var toastEl = document.getElementById('mqDiscountToast');
  var panel = root.querySelector('.mq-welcome-popup__panel');
  var dismissEls = root.querySelectorAll('[data-mq-welcome-dismiss]');

  var opened = false;
  var toastTimer = null;
  var toastLayoutTimer = null;

  function notifyWelcomePopupChange(open) {
    document.dispatchEvent(new CustomEvent('mq:welcome-popup-change', { detail: { open: !!open } }));
  }

  function setEmailMode(on) {
    root.classList.toggle('is-step-2', !!on);
  }

  function setKeyboardMode(on) {
    root.classList.toggle('is-keyboard', !!on);
  }

  function syncViewportLayout() {
    if (!root.classList.contains('is-open') || !window.visualViewport || !panel) return;
    var vv = window.visualViewport;
    var keyboardOpen = vv.height < window.innerHeight * 0.82;
    setKeyboardMode(keyboardOpen);
    if (keyboardOpen && window.innerWidth < 768) {
      panel.style.maxHeight = Math.round(vv.height) + 'px';
    } else {
      panel.style.maxHeight = '';
    }
  }

  function hasStorage(key) {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  }

  function setStorage(key, val) {
    try { window.localStorage.setItem(key, val); } catch (_) {}
  }

  function shouldSkip() {
    if (hasStorage(STORAGE_SUB)) return true;
    var dismissed = hasStorage(STORAGE_DISMISS);
    if (!dismissed) return false;
    var ts = Number(dismissed);
    if (!ts) return false;
    return Date.now() - ts < DISMISS_DAYS * 86400000;
  }

  function showStep(n) {
    steps.forEach(function (el) {
      el.hidden = Number(el.getAttribute('data-step')) !== n;
    });
    root.classList.remove('is-step-1', 'is-step-2', 'is-step-3');
    root.classList.add('is-step-' + n);
    setEmailMode(n === 2);
    if (n !== 2) {
      setKeyboardMode(false);
      if (panel) panel.style.maxHeight = '';
    }
  }

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openPopup() {
    if (opened || shouldSkip()) return;
    opened = true;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    lockScroll(true);
    showStep(1);
    notifyWelcomePopupChange(true);
  }

  function closePopup(dismiss) {
    root.classList.remove('is-open', 'is-step-1', 'is-step-2', 'is-step-3');
    root.setAttribute('aria-hidden', 'true');
    setEmailMode(false);
    setKeyboardMode(false);
    if (panel) panel.style.maxHeight = '';
    lockScroll(false);
    window.setTimeout(function () {
      root.hidden = true;
    }, 350);
    if (dismiss) setStorage(STORAGE_DISMISS, String(Date.now()));
    notifyWelcomePopupChange(false);
  }

  function parseMoney(str) {
    if (!str) return null;
    var cleaned = String(str).replace(/\s/g, '').replace(/[^\d,.-]/g, '').replace(',', '.');
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  function formatMoney(amount) {
    return amount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function discountRate() {
    return (Number(CFG.discountPercent) || 10) / 100;
  }

  function isDiscountActive() {
    return document.body.classList.contains('mq-discount-active');
  }

  function getExtraLabel() {
    var pct = Number(CFG.discountPercent) || 10;
    return '−' + pct + ' % EXTRA appliqué';
  }

  function ensureCardOrigNow(card) {
    if (!card.dataset.origNow) card.dataset.origNow = card.dataset.now || '';
  }

  function syncCardPriceUI(card) {
    if (!card) return;
    ensureCardOrigNow(card);
    var active = isDiscountActive();
    var packPrice = card.dataset.origNow || card.dataset.now || '';
    var msrpEl = card.querySelector('.bundle__price-msrp');
    var packEl = card.querySelector('.bundle__price-pack');
    var nowEl = card.querySelector('.bundle__price .now');
    var extraEl = card.querySelector('.bundle__price-extra');

    if (msrpEl && card.dataset.msrp) msrpEl.textContent = card.dataset.msrp;
    if (packEl) packEl.textContent = packPrice;
    if (nowEl) nowEl.textContent = card.dataset.now || packPrice;
    if (extraEl) extraEl.textContent = getExtraLabel();
  }

  function syncStickyPricing(card) {
    if (!card) return;
    ensureCardOrigNow(card);
    var packPrice = card.dataset.origNow || card.dataset.now || '';
    var msrpEl = document.getElementById('stickyMsrp');
    var packEl = document.getElementById('stickyPack');
    var nowEl = document.getElementById('stickyNow');
    var discEl = document.getElementById('stickyDisc');
    var stickyVariantEl = document.getElementById('stickyVariant');

    if (stickyVariantEl) {
      var title = card.dataset.variantTitle || '';
      var unitNote = card.dataset.unitNote || '';
      stickyVariantEl.textContent = unitNote ? title + ' · ' + unitNote : title;
    }
    if (msrpEl) {
      if (card.dataset.msrp) {
        msrpEl.textContent = card.dataset.msrp;
        msrpEl.hidden = false;
      } else {
        msrpEl.hidden = true;
      }
    }
    if (packEl) packEl.textContent = packPrice;
    if (nowEl) nowEl.textContent = card.dataset.now || packPrice;
    if (discEl) discEl.textContent = getExtraLabel();

    var priceNow = document.getElementById('priceNow');
    if (priceNow) priceNow.textContent = card.dataset.now || packPrice;
  }

  function syncAllBundlePricing() {
    document.querySelectorAll('#bundle .bundle__card').forEach(syncCardPriceUI);
  }

  function syncSelectedPricing(card) {
    card = card || document.querySelector('#bundle .bundle__card.selected');
    if (!card) return;
    syncCardPriceUI(card);
    syncStickyPricing(card);
  }

  function applyVisualDiscount() {
    var rate = discountRate();
    document.querySelectorAll('#bundle .bundle__card').forEach(function (card) {
      ensureCardOrigNow(card);
      var packBase = parseMoney(card.dataset.origNow);
      if (packBase === null) return;
      card.dataset.now = formatMoney(packBase * (1 - rate));
    });

    document.body.classList.add('mq-discount-active');
    setStorage(STORAGE_DISCOUNT_ACTIVE, '1');
    syncAllBundlePricing();
    syncSelectedPricing();
    document.dispatchEvent(new CustomEvent('mq:discount-activated', { detail: { percent: Number(CFG.discountPercent) || 10 } }));
  }

  function markDiscountApplied() {
    syncAllBundlePricing();
    syncSelectedPricing();
  }

  function applyDiscount() {
    var code = CFG.discountCode || 'bonjour10';
    return fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual'
    }).catch(function () {});
  }

  function getSelectedSavingsAmount() {
    var selected = document.querySelector('#bundle .bundle__card.selected');
    if (!selected) return 0;
    var base = parseMoney(selected.dataset.origNow || selected.dataset.was || selected.dataset.now);
    var now = parseMoney(selected.dataset.now);
    if (base === null || now === null) return 0;
    return Math.max(0, base - now);
  }

  function getDiscountToastMessage() {
    var pct = Number(CFG.discountPercent) || 10;
    var savings = getSelectedSavingsAmount();
    return '−' + pct + ' % appliqué · vous économisez ' + formatMoney(savings);
  }

  function flashStickyPrice() {
    var priceEl = document.getElementById('stickyNow');
    if (!priceEl) return;
    priceEl.classList.remove('sticky-atc__now--flash');
    void priceEl.offsetWidth;
    priceEl.classList.add('sticky-atc__now--flash');
    window.setTimeout(function () {
      priceEl.classList.remove('sticky-atc__now--flash');
    }, 600);
  }

  function positionDiscountToast() {
    if (!toastEl) return;
    var sticky = document.getElementById('stickyAtc');
    if (sticky && sticky.classList.contains('is-visible')) {
      toastEl.style.bottom = (sticky.offsetHeight + 12) + 'px';
      return;
    }
    var atc = document.getElementById('atcBtn');
    if (atc) {
      var rect = atc.getBoundingClientRect();
      if (rect.top >= 0 && rect.top < window.innerHeight) {
        toastEl.style.bottom = Math.max(24, window.innerHeight - rect.top + 12) + 'px';
        return;
      }
    }
    toastEl.style.bottom = '24px';
  }

  function bindToastLayoutListeners() {
    function onLayoutChange() {
      if (toastEl && toastEl.classList.contains('is-visible')) positionDiscountToast();
    }
    window.addEventListener('scroll', onLayoutChange, { passive: true });
    window.addEventListener('resize', onLayoutChange);
    document.addEventListener('mq:welcome-popup-change', onLayoutChange);
  }

  function showToast(message) {
    if (!toastEl) return;
    toastEl.textContent = message || getDiscountToastMessage();
    positionDiscountToast();
    toastEl.hidden = false;
    requestAnimationFrame(function () {
      toastEl.classList.add('is-visible');
    });
    flashStickyPrice();
    if (toastTimer) window.clearTimeout(toastTimer);
    if (toastLayoutTimer) window.clearInterval(toastLayoutTimer);
    toastLayoutTimer = window.setInterval(positionDiscountToast, 250);
    toastTimer = window.setTimeout(function () {
      toastEl.classList.remove('is-visible');
      if (toastLayoutTimer) {
        window.clearInterval(toastLayoutTimer);
        toastLayoutTimer = null;
      }
      window.setTimeout(function () {
        toastEl.hidden = true;
        toastEl.style.bottom = '';
      }, 280);
    }, 4000);
  }

  function activateDiscountOnSite() {
    if (activateBtn) activateBtn.disabled = true;
    return applyDiscount()
      .then(function () {
        applyVisualDiscount();
        if (window.mqRefreshCart) window.mqRefreshCart();
        closePopup(false);
        showToast(getDiscountToastMessage());
      })
      .finally(function () {
        if (activateBtn) activateBtn.disabled = false;
      });
  }

  function ensureMetaPixel() {
    var pixelId = CFG.metaPixelId;
    if (!pixelId) return;
    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }
    if (window.fbq && !window._mqWelcomeMetaPixel) {
      window.fbq('init', pixelId);
      window._mqWelcomeMetaPixel = 1;
    }
  }

  function trackWelcomeOfferMeta() {
    if (!CFG.metaPixelId) return;
    ensureMetaPixel();
    if (!window.fbq) return;
    var code = (CFG.discountCodeDisplay || CFG.discountCode || 'bonjour10').toUpperCase();
    var payload = {
      content_name: 'welcome_popup',
      content_category: 'email_discount',
      discount_code: code,
      value: 10,
      currency: 'EUR'
    };
    window.fbq('track', 'Lead', payload);
    window.fbq('trackCustom', 'WelcomePopupClaimed', payload);
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  }

  function subscribeKlaviyo(email) {
    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.klaviyoCompanyId),
      {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: '2024-07-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      source: 'popup',
                      offer: CFG.discountCode || 'bonjour10'
                    }
                  },
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: CFG.klaviyoListId } }
            }
          }
        })
      }
    ).then(function (res) {
      if (res.status === 202 || res.ok) return;
      return res.text().then(function (text) {
        throw new Error(text || ('Klaviyo error ' + res.status));
      });
    });
  }

  function copyCode() {
    var code = (CFG.discountCodeDisplay || 'BONJOUR10').toUpperCase();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        if (copyBtn) copyBtn.classList.add('is-copied');
        window.setTimeout(function () {
          if (copyBtn) copyBtn.classList.remove('is-copied');
        }, 2000);
      });
    }
  }

  if (tryBtn) {
    tryBtn.addEventListener('click', function () {
      showStep(2);
      window.setTimeout(function () {
        if (emailInput) {
          emailInput.focus({ preventScroll: true });
          syncViewportLayout();
        }
      }, 100);
    });
  }

  dismissEls.forEach(function (el) {
    el.addEventListener('click', function () { closePopup(true); });
  });

  if (emailInput) {
    emailInput.addEventListener('focus', function () {
      setEmailMode(true);
      syncViewportLayout();
    });
    emailInput.addEventListener('blur', function () {
      window.setTimeout(syncViewportLayout, 120);
    });
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncViewportLayout);
    window.visualViewport.addEventListener('scroll', syncViewportLayout);
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      showError('');

      var email = (emailInput && emailInput.value || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError('Veuillez entrer une adresse e-mail valide.');
        return;
      }

      var submitBtn = form.querySelector('.mq-welcome-popup__cta');
      if (submitBtn) submitBtn.disabled = true;

      subscribeKlaviyo(email)
        .then(function () {
          trackWelcomeOfferMeta();
          setStorage(STORAGE_SUB, '1');
          if (codeEl) {
            codeEl.textContent = (CFG.discountCodeDisplay || CFG.discountCode || 'bonjour10').toUpperCase();
          }
          showStep(3);
        })
        .catch(function (err) {
          showError('Une erreur est survenue. Réessayez dans un instant.');
          if (window.console && console.warn) console.warn('Welcome popup', err);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  if (copyBtn) copyBtn.addEventListener('click', copyCode);
  if (activateBtn) activateBtn.addEventListener('click', activateDiscountOnSite);

  bindToastLayoutListeners();

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closePopup(true);
  });

  if (hasStorage(STORAGE_DISCOUNT_ACTIVE)) {
    applyVisualDiscount();
  }

  window.mqApplyWelcomeDiscount = applyVisualDiscount;
  window.mqSyncSelectedPricing = syncSelectedPricing;
  window.mqSyncAllBundlePricing = syncAllBundlePricing;

  if (shouldSkip()) return;

  window.setTimeout(openPopup, Number(CFG.delayMs) || 4200);
})();
